import { ANON_ROLE_UID, TYPESENSE_ORGANIZATIONS_COLLECTION_NAME, TYPESENSE_PARTS_COLLECTION_NAME, TYPESENSE_PROJECTS_COLLECTION_NAME, TYPESENSE_USERS_COLLECTION_NAME, } from "@buildwithflux/constants";
import { documentIsPublished, } from "@buildwithflux/models";
import { algoliaFeatureConfig } from "@buildwithflux/search";
const convertBaseDocumentDataToSearchDocumentData = (documentData, options) => ({
    uid: documentData.uid,
    created_at: documentData.created_at,
    updated_at: documentData.updated_at,
    contributor_uids: documentData.contributor_uids || [],
    belongs_to_part_uid: documentData.belongs_to_part_uid,
    is_published: documentIsPublished(documentData),
    partUid: documentData.belongs_to_part_uid,
    userAccessList: documentData.user_access_list ?? [],
    anyoneCanView: documentData.user_access_list?.includes(ANON_ROLE_UID) ?? false,
    name: documentData.name,
    has_custom_name: documentData.has_custom_name,
    slug: documentData.slug,
    owner_handle: documentData.owner_handle,
    owner_uid: documentData.owner_uid,
    is_organization_owned: !!documentData.organization_owner_uid,
    organization_owner_uid: documentData.organization_owner_uid,
    organization_member_permission_type: documentData.organization_member_permission_type,
    organization_owner_is_enterprise_default: documentData.organization_owner_is_enterprise_default,
    enterprise_owner_uid: documentData.enterprise_owner_uid,
    enterprise_owner_handle: documentData.enterprise_owner_handle,
    enterprise_member_permission_type: documentData.enterprise_member_permission_type,
    description: documentData.description,
    archived: documentData.archived,
    usage_count: documentData.usage_count ?? 0,
    star_count: documentData.star_count ?? 0,
    comment_count: documentData.comment_count ?? 0,
    fork_count: documentData.fork_count ?? 0,
    copy_count: documentData.copy_count ?? 0,
    preview_image: documentData.preview_image,
    test_data: options?.isTestData ?? false,
});
export const convertBaseDocumentDataToAlgoliaSearchDocumentData = (documentData, options) => ({
    ...convertBaseDocumentDataToSearchDocumentData(documentData, options),
    objectID: documentData.uid,
});
export const convertBaseDocumentDataToTypesenseSearchDocumentData = (documentData, options) => ({
    ...convertBaseDocumentDataToSearchDocumentData(documentData, options),
    id: documentData.uid,
});
export const getAlgoliaSearchOptions = (searchIndexAlias) => {
    switch (searchIndexAlias) {
        case "components":
            return { hitsPerPage: 25, facetFilters: ["test_data:false", "is_published:true"] }; // no test_data on parts
        case "projects":
            return { hitsPerPage: 25, facetFilters: ["test_data:false", "is_published:false"] };
        default:
            return { hitsPerPage: 25, facetFilters: ["test_data:false"] };
    }
};
export const getTypesenseSearchOptions = (searchIndexAlias) => {
    switch (searchIndexAlias) {
        case "components":
            return { hitsPerPage: 25, facetFilters: ["test_data:false"] }; // no test_data on parts
        case "projects":
            return { hitsPerPage: 25, facetFilters: ["test_data:false", "is_published:false"] };
        default:
            return { hitsPerPage: 25, facetFilters: ["test_data:false"] };
    }
};
// TODO: This is not used? Can we remove it?
export const getAlgoliaSearchIndex = (queryType) => {
    switch (queryType) {
        case "projects": {
            return algoliaFeatureConfig.projectsByStars.primaryIndexName;
        }
        case "components": {
            return algoliaFeatureConfig.parts.primaryIndexName;
        }
        case "users": {
            return algoliaFeatureConfig.users.primaryIndexName;
        }
        case "orgs": {
            return algoliaFeatureConfig.organizations.primaryIndexName;
        }
    }
};
/**
 * Search page is special, because we want to use `projectsByStars` for "components" search there
 *
 * Here we take Typesense into consideration
 */
export const getSearchIndexForSearchPage = (searchProvider, queryType) => {
    switch (queryType) {
        case "projects":
            return TYPESENSE_PROJECTS_COLLECTION_NAME;
        case "components":
            return TYPESENSE_PARTS_COLLECTION_NAME;
        case "users": {
            if (searchProvider === "algolia")
                return algoliaFeatureConfig.users.primaryIndexName;
            return TYPESENSE_USERS_COLLECTION_NAME;
        }
        case "orgs": {
            if (searchProvider === "algolia")
                return algoliaFeatureConfig.organizations.primaryIndexName;
            return TYPESENSE_ORGANIZATIONS_COLLECTION_NAME;
        }
    }
};
//# sourceMappingURL=functions.js.map